import { render } from "./CourseSetting.vue?vue&type=template&id=a87021d2&scoped=true"
import script from "./CourseSetting.vue?vue&type=script&lang=js"
export * from "./CourseSetting.vue?vue&type=script&lang=js"

import "./CourseSetting.vue?vue&type=style&index=0&id=a87021d2&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87021d2"]])

export default __exports__